<script>
    import { createEventDispatcher } from 'svelte';

    export let value = ""
    export let fixedWidth = false
    export let maxLength = undefined

    const dispatch = createEventDispatcher();
    const handleChange = () => dispatch('change', value);

    $: charCount = (value || "").length
    $: if (maxLength !== undefined && value && value.length > maxLength) {
        value = value.slice(maxLength)
    }
</script>

<div class="textareaWrapper" class:fixedWidth>
    <textarea bind:value on:input={handleChange} class:fixedWidth type="text" maxlength={maxLength} {...$$restProps} />
    {#if maxLength !== undefined}
        <span class="characterCount">{charCount}/{maxLength}</span>
    {/if}
</div>

<style>
    .textareaWrapper {
        width: 100%;
        position: relative;
    }

    textarea {
        border-radius: 3px;
        border: 2px solid #ddd;
        min-height: 100px;
        width: 100%;
    }

    .fixedWidth {
        min-width: 100%;
        max-width: 100%;
    }

    .characterCount {
        position: absolute;
        right: 10px;
        bottom: 8px;
        color: #aaa;
        font-size: 0.9em;
        user-select: none;
        pointer-events: none;
        background: white;
    }
</style>
